<div class="luggageCardDs__cont">
  <ng-container *ngIf="title">
    <div class="luggageCardDs__title">
      <app-ds-typography
        [size]="fontSize.XS"
        [color]="fontColor.Primary"
        [fontFamily]="fontFamily.SemiBold"
        [text]="title">
      </app-ds-typography>
    </div>
  </ng-container>
  <ng-container *ngFor="let row of rows; last as isLast">
    <div class="luggageCardDs__row">
      <app-ds-icon
        class="luggageCardDs__row-icon"
        [icon]="getIcon(row)"
        [size]="16"
        [color]="getIconColor(row)">
      </app-ds-icon>
      <app-ds-typography
        class="luggageCardDs__row-title"
        [size]="fontSize.XXXS"
        [tag]="'p'"
        [color]="getTypographyColor(row)"
        [text]="row?.Title">
      </app-ds-typography>
    </div>
    <ng-container *ngIf="row?.Description">
      <div class="luggageCardDs__row-description">
        <app-ds-typography
          [size]="fontSize.XXXS"
          [tag]="'p'"
          [color]="fontColor.Secondary"
          [text]="row?.Description">
        </app-ds-typography>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLast">
      <div class="luggageCardDs__divider">
        <app-ds-divider></app-ds-divider>
      </div>
    </ng-container>
  </ng-container>
</div>